import React, { Dispatch, SetStateAction, useState } from 'react';
import { Alert } from 'react-bootstrap';

import {
  CreateUpdatePurchaseInvoiceDto,
  GetPurchaseInvoiceExtendedDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { PurchaseInvoiceEditorFormEstimateItemPositionsControls } from './PurchaseInvoiceEstimateItemPositionsControls';
import { PurchaseInvoiceTabsEnum } from './PurchaseInvoiceTabsEnum';
import usePurchaseInvoiceEstimateItems from './usePurchaseInvoiceEstimateItems';
import { PurchaseInvoiceEstimateItemPositionsGrid } from './PurchaseInvoiceEstimateItemPositionsGrid';
import { PurchaseInvoiceEstimateItemPositionsFilters } from './PurchaseInvoiceEstimateItemPositionsFilters';
import usePurchaseInvoiceEstimateItemsFilters from './usePurchaseInvoiceEstimateItemsFilters';
import { AlertNoProjectsInEstimateItems } from './AlertNoProjectsInEstimateItems';

interface PurchaseInvoiceEditorFormEstimateItemPositionsProps {
  purchaseInvoice: CreateUpdatePurchaseInvoiceDto;
  extendedPurchaseInvoice?: GetPurchaseInvoiceExtendedDto;
  specialTeamIds?: string[];
  setNotSavedTab: Dispatch<SetStateAction<PurchaseInvoiceTabsEnum | undefined>>;
  handleRefresh: () => Promise<void>;
  readOnly: boolean;
  onlyTV?: boolean;
}

export const PurchaseInvoiceEstimateItemPositions: React.FC<
  PurchaseInvoiceEditorFormEstimateItemPositionsProps
> = props => {
  const { t, tk } = useTranslation('fvzLng');
  const { filters, handleChangeFilters, applyFiltersToEstimateItems } =
    usePurchaseInvoiceEstimateItemsFilters(
      props.extendedPurchaseInvoice,
      props.specialTeamIds,
    );
  const purchaseInvoiceEstimateItemsData = usePurchaseInvoiceEstimateItems({
    ...props,
    applyFiltersToEstimateItems,
    filters,
    t,
    tk,
  });
  const [saveErrors, setSaveErrors] = useState<string[]>([]);

  if (purchaseInvoiceEstimateItemsData.isListEmpty) {
    return <Alert variant="warning">{t(tk.common.noData)}.</Alert>;
  }

  return (
    <>
      <PurchaseInvoiceEstimateItemPositionsFilters
        filters={filters}
        handleChangeFilters={handleChangeFilters}
      />
      <PurchaseInvoiceEstimateItemPositionsGrid
        {...props}
        {...purchaseInvoiceEstimateItemsData}
      />
      <ValidationAlert
        show={!!saveErrors.length}
        errors={saveErrors}
        className="m-0 mt-4"
      />
      <AlertNoProjectsInEstimateItems
        extendedPurchaseInvoice={props.extendedPurchaseInvoice}
        purchaseInvoiceEstimateItems={
          purchaseInvoiceEstimateItemsData.purchaseInvoiceEstimateItems
        }
      />
      <PurchaseInvoiceEditorFormEstimateItemPositionsControls
        {...props}
        {...purchaseInvoiceEstimateItemsData}
        setSaveErrors={setSaveErrors}
      />
    </>
  );
};
